import { callPostApi } from "@/api/api";
import { getChannelName } from "@/config/channels";
import { downloadServerLink,supportLink } from "@/config/config";

export default {
  namespaced: true,
  state: {
    current_channel: "jc", 
    downloads  : {
    downloadWindowsClientLink:"", 
    downloadAndroidClientLink:"", 
    downloadIosClientLink:"", 
    downloadLinuxClientLink:"",
    downloadMacClientLink: "",
   },
   supportLink:""
  },
  mutations: {
    updateChannel(state, data) {
      // state.current_channel = data; 
     
      console.log("updateChannel=================",data)

      if(data) {
        state.current_channel = data.channel_code
        state.downloads.downloadWindowsClientLink = data.downloads.downloadWindowsClientLink
        state.downloads.downloadAndroidClientLink = data.downloads.downloadAndroidClientLink
        state.downloads.downloadIosClientLink = data.downloads.downloadIosClientLink
        state.downloads.downloadLinuxClientLink = data.downloads.downloadLinuxClientLink
        state.downloads.downloadMacClientLink = data.downloads.downloadMacClientLink
        state.supportLink = data.supportLink
      } else {
        state.current_channel = ''
        state.downloads.downloadWindowsClientLink = '';
        state.downloads.downloadAndroidClientLink = '';
        state.downloads.downloadIosClientLink =   '';
        state.downloads.downloadLinuxClientLink = '';
        state.downloads.downloadMacClientLink = '';
        state.supportLink = supportLink ;
      } 

    },
  },
  actions: {
    async setChannel({ commit, state }, payload) { 
      
      const hostName = getChannelName();
      const body = {
              host: hostName
          }
         await callPostApi('/channel','post',JSON.stringify(body),'','en')
          .then(res => {
              if(res.isSuccess && res.data) {
                  commit("updateChannel", res.data);
              } else {
                  console.error( `Error loading translation for language: ${res.message}` );
                  commit("updateChannel", null);
              }
          }).catch(err => {
              console.error( `Error loading translation for language: ${err}` );
              commit("updateChannel", null);
          })
    },
  },
};
